const YES = 'yes';
const NO = 'no';
const observerKey = Symbol('v-observe');

function markObserved(el) {
  el.dataset.vObserved = YES;
}

function markNotObserved(el) {
  el.dataset.vObserved = NO;
}

function cacheObserver(el, observer) {
  el[observerKey] = observer;
}

function removeCachedObserver(el) {
  el[observerKey] = undefined;
}

export default {
  mounted(el, { value: observer }) {
    if (observer instanceof IntersectionObserver) {
      observer.observe(el);
      markObserved(el);
      cacheObserver(el, observer);
    } else {
      markNotObserved(el);
      removeCachedObserver(el);
    }
  },

  updated(el, { value: observer }) {
    const cached = el[observerKey];
    const sameObserver = observer === cached;
    const observed = el.dataset.vObserved === YES;
    const newObserver = observer instanceof IntersectionObserver;

    if (!observed) {
      if (newObserver) {
        observer.observe(el);
        markObserved(el);
        cacheObserver(el, observer);
      }

      return;
    }

    if (!newObserver) {
      markNotObserved(el);

      if (cached) {
        cached.unobserve(el);
        removeCachedObserver(el);
      }

      return;
    }

    if (sameObserver) {
      return;
    }

    if (cached) {
      cached.unobserve(el);
    }

    observer.observe(el);
    markObserved(el);
    cacheObserver(el, observer);
  },

  unmounted(el) {
    const cached = el[observerKey];

    if (cached instanceof IntersectionObserver) {
      cached.unobserve(el);
    }

    markNotObserved(el);
    removeCachedObserver(el);
  },
};
